import httpClient from '@xto10x/core/lib/httpClient';
import storage from '@xto10x/storage/lib/storage';
import { StorageKey } from 'utils/constants';
import config from '../utils/config';

const taskApi = {
  getTaskDetails: task_id => httpClient.get(`/v1/task/${task_id}`),

  updateTaskStatus: (task_id, status) =>
    httpClient.put(`/v1/task/${task_id}/status?status=${status}`),

  getTaskAssignedByUser: cycle_id =>
    httpClient.get(
      `/v1/task/assigned-by-user${cycle_id ? `?cycle-id=${cycle_id}` : ''}`
    ),

  getTaskAssignedToUser: cycle_id =>
    httpClient.get(
      `/v1/task/assigned-to-user${cycle_id ? `?cycle-id=${cycle_id}` : ''}`
    ),

  getAllModuleTasks: () =>
    httpClient.get(
      `${config.taskApiUrl}/tasks`,
      {},
      {
        subdomain: storage.getDataFromLocal(StorageKey.ORG_INFO)?.sub_domain
      }
    )
};

export default taskApi;
